export default __webpack_public_path__ + "static/media/True Trigram Formation.624532cd.png";